import { observable, action,  decorate } from 'mobx';
import agent from '../../api/agent';


class DGRProductStore {
    //DATA//
    inProgress = false
    productDataLoaded = false
    levels = []
    products = {}
    leveledProducts = []
    flattenedProducts = []
    errors = undefined
    featuredProduct = {}

    clearData(){
        this.leveledProducts = [] 
        this.flattenedProducts = []
    }


    getFeaturedProduct(){
        if (this.flattenedProducts.length > 0 ){
            this.flattenedProducts.forEach( (item, index) => {
                if (item.is_featured) {
                   this.featuredProduct = item 
                }
            })
        }
    }

	//make additional function for non flattened products
	processProducts(data){
		if (data.levels){
            this.clearData()
            this.leveledProducts = {}
            this.flattenedProducts = []
            
            this.products = data
            this.levels = data.levels

            //move flatten products to function
            data.levels.forEach( (item, index) => {
                item.products.forEach( (product, index) => {
                    this.flattenedProducts.push(product)
                })
            })

            this.getFeaturedProduct()

            this.productDataLoaded = true
        } 
	}

    getClubProducts(club_number){
        this.inProgress = true;
        this.errors = undefined;
        return agent.DGR.getStoreData( 
            club_number
        ).then( (response) => {
			this.processProducts(response)
			if (response.error){
				//TODO successful error
				console.log(response.error)
			}
			return response
        })
        .catch(action( (err) => {
            //TODO - figure out a loss of connection error
            this.errors = err.message 
            //throw err;
        }))
        .finally(action(() => { 
            this.inProgress = false; 
        }));
    }
    getClubProductsSilent(club_number){
        this.errors = undefined;
        return agent.DGR.getStoreData( 
            club_number
        ).then( (response) => {
			this.processProducts(response)
			if (response.error){
				//TODO successful error
				console.log(response.error)
			}
			return response
        })
        .catch(action( (err) => {
            //TODO - figure out a loss of connection error
            this.errors = err.message 
            //throw err;
        }))
    }
}


decorate(DGRProductStore, {
    inProgress: observable,
    leveledProducts: observable,
    featuredProduct: observable, 
    flattenedProducts : observable,
    errors: observable,
    getClubProducts: action,
    productDataLoaded:observable
})
export default new DGRProductStore();



// WEBPACK FOOTER //
// ./src/stores/DGRProductStore/index.js